import './styles.scss';
import { registerFragment } from "../../registry";
import { DisposalSet } from "../../../utils";
const gc = new DisposalSet();
registerFragment('npt-segmented-content', (fragmentElement, config, meta) => {});
if (import.meta.webpackHot) {
  import.meta.webpackHot.accept();
  import.meta.webpackHot.dispose(() => gc.disposeAll());
}